import Vue from 'vue'
import PostCode from '@/utilities/plugin/postcode'

export default Vue.use(PostCode)
